import { Employee } from "../../../../Utilities";
import { EmployeeFormat } from "../../../Format";
import * as PersonComponents from "../../Person";
import { IconEmployee } from "../Icon";

export type EmployeeIconNameDescriptionProps = Omit<PersonComponents.PersonIconNameDescriptionProps, "person"> & {
	employee: IconEmployee & Pick<Employee, "jobTitle">;
};

export function EmployeeIconNameDescription({ employee, description, ...props }: EmployeeIconNameDescriptionProps) {
	const defaultDescription = EmployeeFormat.Fields.jobTitle(employee.jobTitle) || "Staff";

	return (
		<PersonComponents.PersonIconNameDescription
			person={employee.person}
			description={description ?? defaultDescription}
			linkID={employee.id}
			{...props}
		/>
	);
}
